import {useEffect, useState} from "react";
import {componentTypeMatcher} from "../matchers.jsx";
import React from "react";

export const DebouncedInput = ({
                                   value: initialValue,
                                   onChange,
                                   debounce = 750,
                                   ...props
                               }) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);


    const Component = componentTypeMatcher[props.type]?.component;


    return React.cloneElement(Component, {
        ...props,
        value,
        size: "sm",
        className: value && "border-warning border-3",
        onChange: (e) => {
            let val = props.type === 'multiSelect' ? e : e.target.value
            setValue(val)
        }
    })

}


